export const INTERSECT_DEBOUNCE_TIMER = 500
export const FOLDER_ICON_COLOR = '#7BA9F9'
export const FOLDER_MAX_DEPTH = 1
export const APP_HEADER_HEIGHT = 64
export const ACCEPTED_DOCUMENT_TYPES = ".pdf, .doc, .docx"
export const ACCEPTED_DOWNLOAD_TYPES = [
  'application/pdf',
  'application/msword',
  'application/octet-stream',
]
